export const accountingSettingsGetters = {
  accountingSettingsData: (state) => state.accountingSettingsData
}